import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import type { NodeIconProps } from '../base-node/components/node-icon';
import NodeIcon from '../base-node/components/node-icon';
export type NodeCardProps = {
  icon: NodeIconProps;
  label: string;
  subtitle: string;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
};
const NodeCard = t0 => {
  const $ = _c(25);
  const {
    icon,
    label,
    subtitle,
    isActive: t1,
    onClick,
    className
  } = t0;
  const isActive = t1 === undefined ? false : t1;
  const Container = onClick ? "button" : "div";
  const color = "color" in icon ? icon.color : "primary";
  let t2;
  if ($[0] !== color || $[1] !== isActive) {
    t2 = () => {
      if (isActive) {
        return "border-accent";
      }
      return color === "accent" ? "border-secondary-hover" : "border-tertiary";
    };
    $[0] = color;
    $[1] = isActive;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getBorderColorClassName = t2;
  const bgColor = color === "accent" ? "bg-active" : "bg-primary";
  const t3 = onClick ? "button" : undefined;
  let t4;
  if ($[3] !== bgColor || $[4] !== className || $[5] !== getBorderColorClassName || $[6] !== onClick) {
    t4 = twMerge(cx("relative flex gap-3 w-full max-w-full p-2", "rounded select-none border-[1.5px] border-solid shadow-[0px_1px_8px_0px_rgba(0,0,0,0.08)]", "text-label-2 text-left", "overflow-hidden", bgColor, "transition-colors duration-200", "after:absolute after:rounded after:bg-black/0 after:inset-0 after:transition-colors after:duration-200", {
      "hover:after:bg-neutral-inverted/5 hover:cursor-pointer cursor-pointer": !!onClick
    }, getBorderColorClassName()), className);
    $[3] = bgColor;
    $[4] = className;
    $[5] = getBorderColorClassName;
    $[6] = onClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== icon) {
    t5 = <NodeIcon {...icon} />;
    $[8] = icon;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== label) {
    t6 = <span className="text-caption-2 text-tertiary">{label}</span>;
    $[10] = label;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== subtitle) {
    t7 = <span className="flex-wrap max-w-full text-left wrap-break-word text-label-2 text-primary line-clamp-2">{subtitle}</span>;
    $[12] = subtitle;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="flex flex-col flex-1 gap-1 justify-center items-start min-w-0">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== Container || $[18] !== label || $[19] !== onClick || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t8) {
    t9 = <Container type={t3} onClick={onClick} aria-label={label} className={t4}>{t5}{t8}</Container>;
    $[17] = Container;
    $[18] = label;
    $[19] = onClick;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export default NodeCard;